// extracted by mini-css-extract-plugin
module.exports = {"root":"Layout__root--Yj7SZ","form":"Layout__form--4yOS_","main":"Layout__main--1qVkz Container__pageContainer--3DS44 Container__container--2Emzb"};